import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  template: `<div id="home-component" class="component"></div>`,
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/component/module/home/home.component.ts